import { createContext } from 'react';

import {
  DeviceSoftwareEndOfSupportInput,
  DeviceSoftwareEndOfSupportRecord,
} from '@totem/components/devices/softwareEndOfLife/summary/types';

interface Context {
  input: DeviceSoftwareEndOfSupportInput;
  setInput: (input: DeviceSoftwareEndOfSupportInput) => void;
  loading: boolean;
  data: DeviceSoftwareEndOfSupportRecord[];
  action: string;
  onAction?: (action: string) => void;
}

export default createContext<Context>({
  input: {},
  setInput: () => {},
  loading: false,
  data: null,
  action: '',
  onAction: () => {},
});
